{
  "WALLBOARD": {
    "LOADING": "Cargando colas telefónicas...",
    "NO_QUEUES": "No se encontraron colas telefónicas.",
    "AGENTS": "Agentes",
    "NO_AGENTS": "No hay agentes en línea en esta cola.",
    "NO_AGENTS_ONLINE": "No hay agentes en línea.",
    "WAITING_CALLERS": "Llamantes en espera",
    "NO_CALLERS": "No hay llamantes en espera.",
    "UNKNOWN_CALLER": "Llamante desconocido",
    "POSITION": "Posición",
    "STATUS": "Estado",
    "TIME": "Tiempo",
    "AGENT": "Agente",
    "EXTENSION": "Extensión",
    "AVAILABLE": "Disponible",
    "READY": "Agentes listos",
    "ON_CALL": "Agentes en llamada",
    "QUEUE_CALL": "Llamada de cola",
    "OTHER_CALL": "Otra llamada",
    "PAUSED": "Agentes en descanso",
    "WAITING": "Llamadas en espera",
    "MISSED_CALLS": "Llamadas perdidas",
    "HANDLED_CALLS": "Llamadas entrantes atendidas",
    "OUTBOUND_CALLS": "Llamadas salientes atendidas",
    "AVAILABILITY": "Disponibilidad",
    "AVAILABILITY_TOOLTIP": "Porcentaje de llamadas entrantes contestadas por los agentes (llamadas que fueron atendidas)",
    "TOTAL": "total",
    "AGENTS_COUNT": "({onCall} en llamada / {total} en total)",
    "NO_AVAILABLE": "(nadie en línea)",
    "WAITING_CALLERS_COUNT": "{count} en espera",
    "CALLER": "Llamante",
    "NUMBER": "Número",
    "WAIT_TIME": "Tiempo de espera",
    "QUEUES": "Colas",
    "ACTION": "Acción",
    "PICKUP_CALL": "Atender",
    "PICKING_UP": "Atendiendo...",
    "PICKUP_SUCCESS": "Solicitud de atender la llamada realizada con éxito.",
    "PICKUP_ERROR": "No se pudo atender la llamada. Por favor, inténtalo de nuevo.",
    "PICKUP_DISABLED_TOOLTIP": "No puedes atender una llamada mientras estás en una llamada o desconectado.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Sin acceso"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Sin acceso"
    }
  }
}
